import { defineMessages } from 'react-intl'

export default defineMessages({
  setting: {
    id: 'containers.CustomerOrderUpsertPage.components.PostProduction.settings',
    defaultMessage: '',
  },
  note: {
    id: 'containers.CustomerOrderUpsertPage.components.PostProduction.note',
    defaultMessage: 'Optionally leave a note to the post producer',
  },
})